/** Google proves identity only; Search Console is a separate connection and callback. */
export const GOOGLE_LOGIN_ERRORS = {
  google_login_unavailable: 'Вход через Google на этом сервере пока не настроен.',
  google_login_cancelled:
    'Вход через Google отменён. Можно попробовать снова или выбрать другой способ.',
  google_login_expired: 'Подключение Google устарело или сессия изменилась. Начните заново.',
  google_login_failed: 'Google не подтвердил вход. Попробуйте снова или выберите другой способ.',
  google_not_linked:
    'Этот Google ещё не подключён. Войдите привычным способом и подключите Google в своём профиле. Для нового аккаунта откройте регистрацию.',
  google_email_in_use:
    'Аккаунт с этой почтой уже есть. Войдите в него привычным способом и подключите Google в профиле.',
  google_link_conflict:
    'Этот Google уже подключён к другому аккаунту или в профиле выбран другой Google. Аккаунты не объединяются.',
  google_signup_closed:
    'Регистрация новых команд пока закрыта. Для существующего аккаунта сначала подключите Google в профиле.',
  google_no_team: 'У этого аккаунта больше нет доступа к команде. Обратитесь к её владельцу.',
} as const;
export type GoogleLoginErrorCode = keyof typeof GOOGLE_LOGIN_ERRORS;
export type GoogleLoginIntent = 'login' | 'signup' | 'link';

export interface GoogleIdentityDTO {
  available: boolean;
  linked: { email: string; linkedAt: string } | null;
}
export interface GoogleStartDTO {
  url: string;
}
